import { useNavigate } from 'react-router-dom'

import { FileUploaderCompanyDocumentsSettingsDocument } from 'generated/resources/graphql'

import ExpiredTrialChecker from 'modules/core/components/ExpiredTrialChecker'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import filesStore from 'modules/documents/components/Documents/store'
import UploadFormWizard from 'modules/documents/components/UploadFormWizard'
import { Folder } from 'modules/documents/hooks/useGetFolders'
import { isCompanyPublicSpace } from 'modules/documents/lib/Documents'

interface Props {
  folder?: Folder
  backRoute: string
  space: string
}

const NewCompanyDocument = ({ folder, backRoute, space }: Props) => {
  const navigate = useNavigate()
  const {
    company: { subscription },
  } = useCurrentSession()

  const onClose = () => {
    filesStore.setFiles([])
    navigate(backRoute)
  }

  const description = isCompanyPublicSpace(space)
    ? i18n.t('documents.beta.companyDocumentsUploadModal.descriptionPublic')
    : i18n.t('documents.beta.companyDocumentsUploadModal.descriptionInternal')

  const { data } = useQuery(FileUploaderCompanyDocumentsSettingsDocument, {
    variables: { space },
  })

  const folders = data?.documents.folders || []
  const legalEntity = data?.companies.legalEntitiesConnection.nodes[0]

  return (
    <ExpiredTrialChecker subscription={subscription} onClose={onClose}>
      <UploadFormWizard
        titleDescription={description}
        onClose={onClose}
        selectedFolder={folder}
        folders={folders}
        legalEntity={legalEntity}
        space={space}
      />
    </ExpiredTrialChecker>
  )
}

export default NewCompanyDocument
